// extracted by mini-css-extract-plugin
module.exports = {"action_item":"action_action_item__1m4De","action_item_icon":"action_action_item_icon__KGwaP","action_item_label":"action_action_item_label__Iwl2u"};